import { ImageLoader } from '../../../ImageLoader';
import { TranslationsKeys, useCustomIntl } from '../../../../i18n/i18n';
import addingCards from '../../../../assets/images/userManual/card-management/adding-cards_en-GB.png';
import cardStatuses from '../../../../assets/images/userManual/card-management/card-statuses_en-GB.png';
import removingCards from '../../../../assets/images/userManual/card-management/removing-cards_en-GB.png';
import activatingServices from '../../../../assets/images/userManual/card-management/activating-services_en-GB.png';
import deactivatingServices from '../../../../assets/images/userManual/card-management/deactivating-services_en-GB.png';
import vehicleOverview from '../../../../assets/images/userManual/card-management/vehicle-overview_en-GB.png';
import vehicleConfiguration from '../../../../assets/images/userManual/card-management/vehicle-configuration_en-GB.png';
import activeServices from '../../../../assets/images/userManual/card-management/active-services_en-GB.png';
import failedActivation from '../../../../assets/images/userManual/card-management/failed-activation_en-GB.png';

const images = {
  addingCards,
  cardStatuses,
  removingCards,
  activatingServices,
  deactivatingServices,
  vehicleOverview,
  vehicleConfiguration,
  activeServices,
  failedActivation,
};

export const CardManagementImage = ({
  image,
  title,
}: {
  image: keyof typeof images;
  title: TranslationsKeys;
}) => {
  const { formatMessage } = useCustomIntl();
  return (
    <ImageLoader
      src={images[image]}
      alt={formatMessage({ id: title })}
      className="border"
      enlargeable
    />
  );
};
